import { ChannelHandlers } from './channel-handlers';
import { ControlHandlers } from './control-handlers';
import { VisualizationHandlers } from './visualization-handlers';

/**
 * @deprecated Use individual handler namespaces instead:
 * - ControlHandlers for control operations
 * - ChannelHandlers for channel operations
 * - VisualizationHandlers for visualization operations
 */
export namespace SensorTableHandler {
  export const addControl = ControlHandlers.addControl;
  export const addBatchControls = ControlHandlers.addBatchControls;
  export const updateControl = ControlHandlers.updateControl;

  export const createVirtualChannel = ChannelHandlers.createVirtualChannel;
  export const batchChangeChannels = ChannelHandlers.batchChangeChannels;

  export const toggleConfidence = VisualizationHandlers.toggleConfidence;
  export const toggleVisibility = VisualizationHandlers.toggleVisibility;
  export const overrideEchartsOptionOnControl = VisualizationHandlers.overrideEchartsOptionOnControl;
}

// Re-export the individual handler namespaces for direct usage
export { ChannelHandlers, ControlHandlers, VisualizationHandlers };
